import { GlobalController } from 'src/shared/global/GlobalController'
import InvoiceExemptCancelledReport from './InvoiceExemptCancelledReport.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'invoice-exempt-cancelled',
    name:
      'invoiceExemptCancelled',
    component: InvoiceExemptCancelledReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
